import { render } from "./verify2fa.vue?vue&type=template&id=045d0ca2&ts=true"
import script from "./verify2fa.vue?vue&type=script&lang=ts"
export * from "./verify2fa.vue?vue&type=script&lang=ts"

import "./verify2fa.vue?vue&type=style&index=0&id=045d0ca2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__